/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveCabinetIcon20Light = forwardRef('ArchiveCabinetIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M8 6.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5Z" }),
        React.createElement("path", { d: "M8.5 13a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1h-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7 2a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H7Zm8 3a2 2 0 0 0-2-2H7a2 2 0 0 0-2 2v4h10V5ZM5 10h10v5a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2v-5Z" })));
});
